import React from "react";
import { WSBadge, WSBadgeProps } from "@wingspanhq/fe-component-library";
import { MemberClientTaxStatus } from "@wingspanhq/payments/dist/interfaces";

import styles from "./styles.module.scss";

interface BadgeProps {
  props: WSBadgeProps;
  textSuffix: string;
}

function getBadgeProps(taxStatus: MemberClientTaxStatus): BadgeProps {
  switch (taxStatus) {
    case MemberClientTaxStatus.Complete:
      return {
        props: {
          backgroundColor: "green100",
          textProps: {
            color: "green500"
          },
          rightIcon: {
            ml: "XS",
            name: "successMark",
            color: "green500"
          }
        },
        textSuffix: "Verified"
      };
    case MemberClientTaxStatus.Incomplete:
    case MemberClientTaxStatus.Pending:
      return {
        props: {
          backgroundColor: "yellow100",
          textProps: {
            color: "yellow500"
          },
          rightIcon: {
            ml: "XS",
            name: "danger",
            color: "yellow500"
          }
        },
        textSuffix: "Verify"
      };
    default:
      return {
        props: {
          backgroundColor: "grey200",
          textProps: {
            color: "grey700"
          },
          rightIcon: {
            ml: "XS",
            name: "clock",
            color: "grey700"
          }
        },
        textSuffix: "Verifying"
      };
  }
}

export interface TaxIDProps {
  taxId?: string;
  taxStatus: MemberClientTaxStatus;
}

export const TaxID: React.FC<TaxIDProps> = ({
  taxId = "XXXXXXXXX",
  taxStatus
}) => {
  const taxIdLast4 = taxId.slice(-4);
  const { props, textSuffix } = getBadgeProps(taxStatus);

  return (
    <WSBadge
      className={styles.badge}
      {...props}
      text={`•••${taxIdLast4} ${textSuffix}`}
    />
  );
};
